<div id="message">
  <div id="aiz-loader" class="assurant-loader-wraper">
    <div class="assurant-loader">
      <div class="progress-line"></div>
    </div>
  </div>
</div>
